import { render, staticRenderFns } from "./AppFaq.vue?vue&type=template&id=13d6154f&scoped=true&"
import script from "./AppFaq.vue?vue&type=script&lang=js&"
export * from "./AppFaq.vue?vue&type=script&lang=js&"
import style0 from "./AppFaq.vue?vue&type=style&index=0&id=13d6154f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6154f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d6154f')) {
      api.createRecord('13d6154f', component.options)
    } else {
      api.reload('13d6154f', component.options)
    }
    module.hot.accept("./AppFaq.vue?vue&type=template&id=13d6154f&scoped=true&", function () {
      api.rerender('13d6154f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_eagle_landing/components/AppFaq.vue"
export default component.exports